import { RoleGaurd } from "components/layout/RoleGaurd";
import React, { useEffect } from "react";
import Accordion from "react-bootstrap/Accordion";
import Nav from "react-bootstrap/Nav";
import { Link, useParams } from "react-router-dom";
import PropTypes from "prop-types";

import { MenuList, MenuTypes } from "configs/menuList";
import { formatUrlPathScopes } from "utils/functions";
import { useWoundManagementHook } from "hooks/woundManagement/useWoundManagementHook";
export const GenerateAsideMenu = ({ pathname, menuList = MenuList }) => {

  return menuList.map((menu) => {
    if (menu.type === MenuTypes.GROUP) {
      return (
        <MenuGroup menu={menu} key={menu.title} pathname={pathname}>
          <GenerateAsideMenu pathname={pathname} menuList={menu.items} />
        </MenuGroup>
      );
    }
    if (menu.type === MenuTypes.COLLAPSE) {
      return (
        <RoleGaurd module={menu.module} permission={menu.permission} key={menu.title}>
          <li>
            <MenuCollapseItems menu={menu} key={menu.title} pathname={pathname}>
              <GenerateAsideMenu pathname={pathname} menuList={menu.items} />
            </MenuCollapseItems>
          </li>
        </RoleGaurd>
      );
    }
    if (menu.type === MenuTypes.COLLAPSE_LIST) {
      return (
        <RoleGaurd module={menu.module} permission={menu.permission} key={menu.title}>
          <Nav.Item key={menu.title}>
            <MenuCollapseItems menu={menu} key={menu.title} pathname={pathname}>
              <GenerateAsideMenu pathname={pathname} menuList={menu.items} />
            </MenuCollapseItems>
          </Nav.Item>
        </RoleGaurd>
      );
    }
    if (menu.type === MenuTypes.ITEM) {
      return (
        <RoleGaurd module={menu.module} permission={menu.permission} key={menu.title}>
          <li>
            <MenuItem item={menu} key={menu.title} pathname={pathname} />
          </li>
        </RoleGaurd>
      );
    }
    return null;
  });
};

GenerateAsideMenu.propTypes = {
  pathname: PropTypes.string.isRequired,
  menuList: PropTypes.arrayOf(PropTypes.object),
};

function MenuGroup({ menu, children }) {
  return (
    <div className="components">
      <div className="components-head">
        <span>{menu.title}</span>
      </div>
      <ul className="list-unstyled main-menu">{children}</ul>
    </div>
  );
}

MenuGroup.propTypes = {
  menu: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};

function MenuCollapseItems({ menu, pathname, children }) {
  return (
    <Accordion defaultActiveKey={pathname?.indexOf(menu?.eventKey) !== -1 ? menu?.eventKey : false}>
      <Accordion.Item eventKey={menu.eventKey || menu.title}>
        <Accordion.Header as="div" className="sidebar-link">
          <span className={`${menu.icon}`}></span>
          <span className="sidebar-link-text text-truncate">{menu.title}</span>
        </Accordion.Header>
        <Accordion.Body>
          <ul className="list-unstyled sub-menu">{children}</ul>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
}

MenuCollapseItems.propTypes = {
  menu: PropTypes.object.isRequired,
  pathname: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

function MenuItem({ item, pathname }) {
  const params = useParams();
  const {visitListing, visitListingData } = useWoundManagementHook();
  const fetchVisitList = async () => {
    await visitListing({
      page: 1,
      pageSize: 10,
      adminAction: "Needs Review",
    });
  };
  useEffect(() => {
    fetchVisitList();
  }, []);
  const { pathWithoutScope } = formatUrlPathScopes(pathname, params, "View");
  const normalizedHref = item.href.startsWith("/") ? item.href : `/${item.href}`;

  const isWoundManagement = visitListingData?.readOnlyData?.needsReviewCount>0 && item.title === "Wound Management";

  return (
    <Link
      className={`sidebar-link ${pathWithoutScope === normalizedHref ? " active" : ""} ${
        item.linkClassName ? item.linkClassName : ""
      }`}
      to={normalizedHref}
    >
      {item.type === MenuTypes.ITEM && <span className={isWoundManagement ?`${item.icon} red-bullet` :`${item.icon}`}></span>}
      <span
  className={`sidebar-link-text ${item.titleClassName ? item.titleClassName : ""} text-truncate`}
>
  {item.title}
  {/* {isWoundManagement && ()} */}
</span>
    </Link>
  );
}

MenuItem.propTypes = {
  item: PropTypes.object.isRequired,
  pathname: PropTypes.string.isRequired,
};
